import React from 'react';
import ReactDOM from 'react-dom';
import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';

import { Router, Link, browserHistory, withRouter } from 'react-router';
import { Reactive } from '../common/Reactive.mixin.js';
var RingLoader = require('halogen/PulseLoader');
var uniqid = require('uniqid');
import {
	Well,
	Table,
	Button,
	Form,
	FormGroup,
	Col,
	Checkbox,
	ControlLabel,
	FormControl,
	Breadcrumb,
	BreadcrumbItem,
	Grid,
	BPanel,
	Radio,
	Jumbotron,
	Icon
} from '@sketchpixy/rubix';
import { SelectFlightComponent } from './components/component-flights-type-select';
import { AddPassengersComponent } from './components/component-add-passengers';
import { TotalPriceComponent } from './components/component-total-price';

import { Reservations } from '../../collections/reservations/reservations';
import { FlightsType } from '../../collections/flights-type/flights-type';
import { Prices } from '../../collections/flights-type/prices';
import { Promotions } from '../../collections/flights-type/promotions';
import { Options } from '../../collections/flights-type/options';
import { Passengers } from '../../collections/reservations/passengers';
import { Addresses } from '../../collections/reservations/addresses';

@withRouter
@Reactive({
	subscriptions: ["reservations", "flights-type", "users", "passengers"]
})
export default class ReservationsAddPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.state.tempID = uniqid.process();

		this.state.passengers = [];
		this.state.autocompleted = false;

		//Manual add :
		this.state.manualAdd = true;

		props.ready.then(() => {
			this.setState({
				selectedFlight: FlightsType.findOne({}, { sort: { 'title': 1 } }),
				period: 'SEMAINE',
				options: [],
				promotions: null,
				livraisonType: 1,
				place: 'anjou',
				passengers: Passengers.find({tempID: this.state.tempID}).fetch(),
				maxPassengers: parseInt(FlightsType.findOne({}, { sort: { 'title': 1 } }).constraintPassengerMax),
				autocompleted: false
			});

			Tracker.autorun(() => {
				this.setState({
					'passengers' : Passengers.find({tempID: this.state.tempID}).fetch(),
				});
			});

		});

	}

	selectFlight(event) {
		if(event.target.value != '-') {
			let flight = FlightsType.findOne({_id:event.target.value});
			this.setState({
				maxPassengers: parseInt(flight.constraintPassengerMax),
				selectedFlight: flight,
				prices: flight.prices,
				options: [],
				promotions: null
			});

		}
	}

	selectPeriod(event) {
		this.setState({
			period: event.target.value
		});
	}

	selectPlace(event) {
		this.setState({
			place: event.target.value
		});
	}

	selectOptions(event) {

		console.log('selectOptions', event);

		let option = Options.find({_id: event.target.value}).fetch()[0];
		let options = this.state.options;

		if(_.filter(this.state.options, {_id:option._id}).length > 0) {
			options =  _.reject(this.state.options, (item) => { return item._id == option._id; });
		} else {
			options.push(option);
		}

		this.setState({
			options: options
		});
	}

	selectPromotions(event) {
		let promotion = Promotions.find({_id: event.target.value}).fetch()[0];
		let promotions = this.state.options;

		if(!promotion) {
			this.setState({
				promotions: null
			});
			this.calculPrice();

			return;
		}

		if(_.filter(this.state.promotions, {_id:promotion._id}).length > 0) {
			promotions =  _.reject(this.state.promotions, (item) => { return item._id == option._id; });
		} else {
			promotions.push(promotion);
		}

		this.setState({
			promotions: promotions
		});

		this.calculPrice();
	}

	selectFreeFlights(value) {
		if(this.state.freeFlights) {
			this.setState({
				freeFlights: false
			});
		} else {
			this.setState({
				freeFlights: true
			});
		}
	}

	addPassenger(event) {
		if(this.state.passengers && this.state.passengers.length >= this.state.maxPassengers) {
			Messenger().post({
				message: "Erreur, ce vol est limité à " + this.state.maxPassengers + " passagers",
				type: "error"
			});
			return;
		}

		let params = {
			'firstName' : ReactDOM.findDOMNode(this.refs.passenger_first_name).value.trim(),
			'lastName' : ReactDOM.findDOMNode(this.refs.passenger_last_name).value.trim(),
			'age' : ReactDOM.findDOMNode(this.refs.passenger_age).value.trim(),
			'weight' : ReactDOM.findDOMNode(this.refs.passenger_weight).value.trim(),
			'phone' : ReactDOM.findDOMNode(this.refs.passenger_phone).value.trim(),
			'email' : ReactDOM.findDOMNode(this.refs.passenger_email).value.trim(),
			'info' : ReactDOM.findDOMNode(this.refs.passenger_info).value.trim(),
			'mobility' : JSON.parse(ReactDOM.findDOMNode(this.refs.passenger_mobility).value),
			'tempID' : this.state.tempID
		};

		ReactDOM.findDOMNode(this.refs.passenger_first_name).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_last_name).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_age).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_weight).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_phone).value = '';
		ReactDOM.findDOMNode(this.refs.passenger_info).value = '';

		Meteor.call('passengers.insert', params, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: err,
					type: "error"
				});
				return;
			}

			Messenger().post({
				message: 'Le passager a bien été ajouté.',
				type: "success"
			});

		}));

	}

	calculBetterPrice(passenger) {

		if(passenger.age <= 12 && this.state.selectedFlight.priceEnfant)
			return this.hasPromotion(this.state.selectedFlight.priceEnfant);

		if(this.state.period == 'SEMAINE' && this.state.selectedFlight.priceSemaine)
			return this.hasPromotion(this.state.selectedFlight.priceSemaine);

		return this.hasPromotion(this.state.selectedFlight.priceLibreDate);

	}

	hasPromotion(price) {
		if(this.state.promotions) {
			return Math.floor(price - (price * (this.state.promotions[0].percentage/100)));
		} else {
			return price;
		}
	}

	calculPrice() {
		let price = 0;
		_.each(this.state.passengers, (passenger) => {
			price+= this.calculBetterPrice(passenger);

			// Mise à jour du passager :
			Passengers.update(passenger._id, { "$set": {price: this.calculBetterPrice(passenger)} });
		});

		return price;
	}

	handleSubmit(e) {
		e.preventDefault();
		let delivery = {};

		let subscriber = {
			civility: ReactDOM.findDOMNode(this.refs.subscriber_civility).value.trim(),
			name: ReactDOM.findDOMNode(this.refs.subscriber_name).value.trim(),
			street: ReactDOM.findDOMNode(this.refs.subscriber_street).value.trim(),
			city: ReactDOM.findDOMNode(this.refs.subscriber_city).value.trim(),
			phone: ReactDOM.findDOMNode(this.refs.subscriber_phone).value.trim(),
			email: ReactDOM.findDOMNode(this.refs.subscriber_email).value.trim(),
		};

		if(ReactDOM.findDOMNode(this.refs.delivery_name).value && ReactDOM.findDOMNode(this.refs.delivery_street).value && ReactDOM.findDOMNode(this.refs.delivery_city).value) {
			delivery = {
				civility: ReactDOM.findDOMNode(this.refs.delivery_civility).value.trim(),
				name: ReactDOM.findDOMNode(this.refs.delivery_name).value.trim(),
				street: ReactDOM.findDOMNode(this.refs.delivery_street).value.trim(),
				city: ReactDOM.findDOMNode(this.refs.delivery_city).value.trim(),
			};

		} else {
			delivery = subscriber;
		}
		
		/*
		 * TODO : add livraisonType info and make it required
		 */
		let reservation = {
			'subscriber': subscriber,
			'delivery': delivery,
			'passengers': _.map(this.state.passengers, (passenger) => { return passenger._id; }),
			'selectedFlight': this.state.selectedFlight._id,
			'place': this.state.place,
			'period': this.state.period,
			//'options': _.map(this.state.options, (option) => { return option._id; }),
			'promotions': _.map(this.state.promotions, (promotion) => { return promotion._id; }),
			'price': this.calculPrice(),
			'bill': false,
			'payment': 1,
			'state': 2,
			'livraisonType': this.state.livraisonType,
			'searchName': ReactDOM.findDOMNode(this.refs.subscriber_name).value.trim(),
			'userId': (_.includes(Meteor.user().roles, 'partner') ? Meteor.user()._id : null),
			'freeFlights': (this.state.freeFlights) ? true : false
		};

		if(reservation.freeFlights)
			reservation.price = 0;

		Meteor.call('reservations.insert', reservation, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: "Erreur...",
					type: "error"
				});
				return;
			}

			Messenger().post({
				message: "La réservation a été enregistrée.",
				type: "success"
			});

			this.props.router.push('/reservations');

		}).bind(this));

	}

	autocomplete() {
		this.setState({'autocompleted': !this.state.autocompleted});
		console.log('autocompleted', this.state.autocompleted);
		if(!this.state.autocompleted) {
			ReactDOM.findDOMNode(this.refs.subscriber_civility).value = "Société";
			ReactDOM.findDOMNode(this.refs.subscriber_name).value = Meteor.user().profile.firstName + ' ' + Meteor.user().profile.lastName;
			ReactDOM.findDOMNode(this.refs.subscriber_street).value = Meteor.user().profile.street;
			ReactDOM.findDOMNode(this.refs.subscriber_city).value = Meteor.user().profile.city;
			ReactDOM.findDOMNode(this.refs.subscriber_phone).value = Meteor.user().profile.phone;
			ReactDOM.findDOMNode(this.refs.subscriber_email).value = Meteor.user().profile.email;
		} else {
			ReactDOM.findDOMNode(this.refs.subscriber_civility).value = "";
			ReactDOM.findDOMNode(this.refs.subscriber_name).value = "";
			ReactDOM.findDOMNode(this.refs.subscriber_street).value = "";
			ReactDOM.findDOMNode(this.refs.subscriber_city).value = "";
			ReactDOM.findDOMNode(this.refs.subscriber_phone).value = "";
			ReactDOM.findDOMNode(this.refs.subscriber_email).value = "";
		}
	}

	renderFlights() {
		return this.props.flights.map((flight) => (
			<option value={flight._id}>{flight.title}</option>
		));
	}

	renderManuelAdd() {
		return (
			<div>
				<Col sm={6}>
					Prix total <FormControl type="text" ref="manual_price"/><br/>
					N° Billet <FormControl type="text" ref="id_billet"/><br/>
				</Col>
			</div>
		);
	}

	render() {

		if(!this.props.isReady && this.state.selectedFlight) {
			return (
				<RingLoader/>
			);
		}

		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/reservations">Reservations</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Créer une réservation
					</Breadcrumb.Item>
				</Breadcrumb>
				<Well><center>Pour créer une réservation, merci de compléter le formulaire ci-dessous :</center></Well>

				<Form horizontal onSubmit={this.handleSubmit.bind(this)}>
					<Col sm={6}>
						<BPanel header="SOUSCRIPTEUR">
							{_.includes(Meteor.user().roles, 'partner') &&
							<center>
								<Checkbox inline onChange={(event) => this.autocomplete() } ref="autocompleted"> Autocompléter avec mes informations</Checkbox>
								<hr/>
							</center>
							}
							<FormGroup>
								<Col sm={3}>
									Civilité
								</Col>
								<Col sm={9}>
									<FormControl componentClass="select" type="select" ref="subscriber_civility">
										<option value="M.">M.</option>
										<option value="Mme">Mme</option>
										<option value="Société">Société</option>
									</FormControl>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									Nom / Prénom
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="subscriber_name"required/>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									N° / Voie
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="subscriber_street" required/>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									Code postal / Ville
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="subscriber_city" required/>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									Téléphone
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="subscriber_phone" required/>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									Email
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="subscriber_email" required/>
								</Col>
							</FormGroup>
						</BPanel>
					</Col>

					<Col sm={6}>
						<BPanel header="LIVRAISON DU BILLET (SI DIFFÉRENT)">
							<FormGroup>
								<Col sm={3}>
									Civilité
								</Col>
								<Col sm={9}>
									<FormControl componentClass="select" type="select" ref="delivery_civility">
										<option value="M.">M.</option>
										<option value="Mme">Mme</option>
										<option value="Société">Société</option>
									</FormControl>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									Nom / Prénom
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="delivery_name"/>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									N° / Voie
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="delivery_street"/>
								</Col>
							</FormGroup>
							<FormGroup>
								<Col componentClass={ControlLabel} sm={3}>
									Code postal / Ville
								</Col>
								<Col sm={9}>
									<FormControl type="text" ref="delivery_city"/>
								</Col>
							</FormGroup>
						</BPanel>
					</Col>

					{/*this.renderManuelAdd()*/}

					<SelectFlightComponent
						selectedFlight={this.state.selectedFlight}
						selectPeriod={this.selectPeriod.bind(this)}
						selectPlace={this.selectPlace.bind(this)}
						selectOptions={this.selectOptions.bind(this)}
						selectPromotions={this.selectPromotions.bind(this)}
						onUpdate={this.selectFlight.bind(this)}>
					</SelectFlightComponent>

					<AddPassengersComponent
						passengers={this.state.passengers}
						flight={this.state.selectedFlight}
						tempID={this.state.tempID}
						onUpdate={this.addPassenger}
						calculBetterPrice={this.calculBetterPrice.bind(this)}
						maxPassengers={this.state.maxPassengers}>
					</AddPassengersComponent>

					<Col sm={4}>
						{_.includes(Meteor.user().roles, 'partner') && Meteor.user().profile.freeFlights > 0 && Meteor.user().profile.freeFlights >= this.state.passengers.length &&
							<Well>
								<Checkbox ref="freeFlights" inline onChange={this.selectFreeFlights.bind(this)}>Vols offerts </Checkbox>   ({Meteor.user().profile.freeFlights} restants)
							</Well>
						}
						<BPanel header="Montant de la réservation">
							<TotalPriceComponent
								calculPrice={this.calculPrice.bind(this)}
								livraisonType={this.state.livraisonType}>
							</TotalPriceComponent>
						</BPanel>
					</Col>

				</Form>
			</div>
		);
	}
}

ReservationsAddPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/page-reservations-add.js
 **/